import { useState } from 'react';

import Modal from '../Modal';
import Button from '../Button';

import { IAdvantages } from './interface';
import bemClassName from '../../utils/bem';

import './index.scss';

const advantagesSticker = bemClassName('advantages-sticker');

const AdvantagesSticker: React.FC<IAdvantages> = ({ data, crossedOut, onClick }) => {
  const [isOpen, setOpen] = useState(false);
  const [modalContent, setModalContent] = useState<React.ReactNode>(null);

  const handleCloseModal = () => {
    setOpen(false);
  };
  const handleOpenModal = (content: React.ReactNode) => {
    setModalContent(content);
    setOpen(true);
    if (onClick) onClick();
  };

  const contentContactless = (
    <>
      <h3>Что такое бесконтактное заселение?</h3>
      <p>
        Квартиры с бесконтактным заселением оборудованы кодовым замком. После бронирования и оплаты
        в СМС или в нашем приложении Вы получите код доступа в квартиру, который будет действовать
        весь срок Вашего пребывания.
      </p>
      <p>
        Опция доступна для гостей, подтвердивших свою личность и согласившихся с правилами
        проживания.
      </p>
    </>
  );

  const contentContact = (
    <>
      <h3>Что такое обычное заселение?</h3>
      <p>
        Обычное заселение подразумевает выезд нашего агента для встречи с Вами. Это необходимо
        тогда, когда Вы еще не валидировали свой аккаунт в личном кабинете. В этом случае агент
        лично проверит Ваш паспорт и составит договор.
      </p>
      <p>
        Также контактное заселение возможно в случае, если квартира еще не оборудована кодовым
        замком или кей-боксом.
      </p>
    </>
  );

  return (
    <div className={advantagesSticker()}>
      {data.map((item, id) => {
        const contentToShow =
          item === 'Бесконтактное заселение' ? contentContactless : contentContact;
        return (
          <p
            className={advantagesSticker('item', {
              clickable: true,
              crossed: crossedOut,
            })}
            key={id}
            onClick={() => {
              handleOpenModal(contentToShow);
            }}>
            {item}
          </p>
        );
      })}
      <Modal open={isOpen} handleClose={handleCloseModal}>
        {modalContent}
        <Button text="Ок" handleExternal={handleCloseModal} />
      </Modal>
    </div>
  );
};

export default AdvantagesSticker;
